// extracted by mini-css-extract-plugin
export default {"search-icon":"_6GPPw","searchIcon":"_6GPPw","clear-btn":"_27iXX","clearBtn":"_27iXX","empty":"_38t7A","disabled":"swyEn"};